// Presentation only: the backend's role-filtered menu remains the source of access.
const sections = [
  { id: 'inicio', title: '', order: 0 },
  { id: 'catalogos', title: 'Catálogos', order: 1 },
  { id: 'operacion', title: 'Operación', order: 2 },
  { id: 'administracion', title: 'Administración', order: 3 },
  { id: 'consultas', title: 'Consultas', order: 4 },
  { id: 'otros', title: 'Otros accesos', order: 5 },
]

const modules = {
  dashboard: { section: 'inicio', order: 0, text: 'Inicio', icon: 'dashboard' },
  transit: {
    section: 'operacion',
    order: 0,
    text: 'Gestión Aduanera',
    icon: 'assignment',
  },
  logistica: { section: 'operacion', order: 1, icon: 'local_shipping' },
  envios: { section: 'operacion', order: 1, icon: 'local_shipping' },
  facturas: { section: 'operacion', order: 2, icon: 'receipt' },
  contabilidad: { section: 'operacion', order: 3, icon: 'account_balance' },
  reportes: { section: 'consultas', order: 0, icon: 'assessment' },
  notificaciones: {
    section: 'consultas',
    order: 1,
    icon: 'notifications_none',
  },
  laboratorios: { section: 'catalogos', order: 0, icon: 'local_hospital' },
  distribuidores: { section: 'catalogos', order: 1, icon: 'business' },
  productos: { section: 'catalogos', order: 2, icon: 'inventory_2' },
  usuarios: { section: 'administracion', order: 0, icon: 'people_outline' },
  admin: {
    section: 'administracion',
    order: 1,
    text: 'Configuración',
    icon: 'settings',
  },
  logs: {
    section: 'administracion',
    order: 2,
    text: 'Registro de actividad',
    icon: 'history',
  },
}

const operationalCatalogs = [
  '/admin/transportistas',
  '/admin/organos-anuentes',
  '/admin/documentos-transporte',
  '/admin/bitacoras',
  '/admin/motivos-pendientes',
  '/admin/feriados',
]

const target = to => {
  if (!to || !to.startsWith('/')) return null
  return new URL(to, 'http://navigation.local')
}
const pathOf = to => {
  const url = target(to)
  return url ? url.pathname.replace(/\/$/, '') : ''
}
const leaves = item =>
  item.children
    ? item.children.reduce((all, child) => all.concat(leaves(child)), [])
    : [item]

export const isMenuLinkActive = (to, route) => {
  const url = target(to)
  if (!url || !route || pathOf(to) !== (route.path || '').replace(/\/$/, ''))
    return false
  return [...new Set(url.searchParams.keys())].every(key => {
    const expected = url.searchParams.getAll(key)
    const value = (route.query || {})[key]
    const current = Array.isArray(value)
      ? value.map(String)
      : value == null
      ? []
      : [String(value)]
    return (
      expected.length === current.length &&
      expected.every((v, i) => v === current[i])
    )
  })
}

export const isMenuGroupActive = (item, route) => {
  const links = leaves(item)
  if (links.some(link => isMenuLinkActive(link.to, route))) return true
  const current = (route && route.path) || ''
  if (
    links.some(
      link => pathOf(link.to) && current.startsWith(pathOf(link.to) + '/')
    )
  )
    return true
  const roots = [
    ...new Set(
      links.map(link => pathOf(link.to).split('/')[1]).filter(Boolean)
    ),
  ]
  return (
    roots.length === 1 &&
    roots[0] !== 'admin' &&
    current.startsWith('/' + roots[0] + '/')
  )
}

export const organizeNavigation = items => {
  const seen = new Set()
  const clean = nodes =>
    (nodes || []).reduce((result, node) => {
      if (!node || node.isActive === false || node.isActive === 0) return result
      if (Array.isArray(node.children)) {
        const children = clean(node.children)
        if (children.length) result.push({ ...node, children })
      } else {
        const url = target(node.to)
        if (!url) return result
        url.searchParams.sort()
        const key = url.pathname.replace(/\/$/, '') + url.search
        if (!seen.has(key)) {
          seen.add(key)
          result.push({ ...node })
        }
      }
      return result
    }, [])
  const normalized = clean(items)
  const catalogs = []
  const roots = normalized.reduce((all, node) => {
    const children = node.children || []
    const retained = children.filter(child => {
      if (!child.children && operationalCatalogs.includes(pathOf(child.to))) {
        catalogs.push(child)
        return false
      }
      return true
    })
    if (!children.length || retained.length)
      all.push(children.length ? { ...node, children: retained } : node)
    return all
  }, [])
  if (catalogs.length)
    roots.push({
      text: 'Catálogos operativos',
      icon: 'tune',
      group: 'catalogos-operativos',
      section: 'administracion',
      order: 3,
      children: catalogs.sort(
        (a, b) =>
          operationalCatalogs.indexOf(pathOf(a.to)) -
          operationalCatalogs.indexOf(pathOf(b.to))
      ),
    })

  const grouped = sections.map(section => ({ ...section, items: [] }))
  roots.forEach((node, index) => {
    const roots = [
      ...new Set(leaves(node).map(link => pathOf(link.to).split('/')[1])),
    ]
    const module = roots.length === 1 ? modules[roots[0]] : null
    const section = node.section || (module && module.section) || 'otros'
    grouped
      .find(group => group.id === section)
      .items.push({
        ...node,
        text:
          module &&
          module.text &&
          (node.children || ['dashboard', 'logs'].includes(roots[0])) &&
          node.group !== 'catalogos-operativos'
            ? module.text
            : node.text,
        icon:
          node.group === 'catalogos-operativos'
            ? node.icon
            : (module && module.icon) || node.icon,
        navigationOrder:
          node.order == null ? (module ? module.order : index) : node.order,
      })
  })
  return grouped
    .filter(section => section.items.length)
    .map(section => ({
      ...section,
      items: section.items.sort(
        (a, b) => a.navigationOrder - b.navigationOrder
      ),
    }))
}
